module.exports = __webpack_public_path__ + "img/img-header-mobile.e6259cd.png";